import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { RichTextEditor } from "@gull";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  getNotificationById,
  updateNotification,
  getNotification,
} from "app/services/memberService";

const validationModel = yup.object().shape({
  notificationSubject: yup
    .string()
    .required("Notification Subject is required!"),
  notificationDescription: yup
    .string()
    .required("Notification Description is required!"),
  status: yup.boolean().required("IFSC Code is required!"),
});

const EditNotification = ({ id, refreshData }) => {
  const [model, setModel] = useState([]);
  const notificationItem = [
    { value: "General", label: "General" },
    { value: "Promo", label: "Promo" },
    { value: "Others", label: "Others" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await getNotificationById(id);
      setModel(data);
    };

    if (id && id !== model.id) {
      fetchData();
    }
  }, [id, model.id]);

  const handleSubmit = async (values) => {
    try {
      const response = await updateNotification(values);
      if (response) {
        NotificationManager.success("Notification saved successfully");
        document.querySelectorAll(".btn-close")[1].click();
        setTimeout(async () => {
          await refreshData();
        }, 100);
      }
    } catch (error) {
      throw error;
    }
  };

  const formik = useFormik({
    initialValues: model,
    validationSchema: validationModel,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  const notificationHandler = (value) => {
    formik.setFieldValue("notificationDescription", value);
  };

  return (
    <div
      className="modal fade"
      id="EditNotificationModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addNewNotificationLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addNewNotificationLabel">
              Modal title
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body m-2">
            <form
              className="needs-validation"
              onSubmit={formik.handleSubmit}
              noValidate
            >
              <Row className="mb-2">
                <Col>
                  <RenderSelectInput
                    name="notificationSubject"
                    display="Notification Type"
                    placeholder="Notification Type"
                    value={formik.values.notificationSubject}
                    error={formik.errors.notificationSubject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.notificationSubject}
                    items={notificationItem}
                    required
                  ></RenderSelectInput>
                </Col>
                <Col>
                  <RenderSelectInput
                    name="status"
                    display="Status"
                    placeholder="Status"
                    value={formik.values.status}
                    error={formik.errors.status}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    required
                  ></RenderSelectInput>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col className="mb-2 m-1">
                  <label> Notification Details :</label>
                  <RichTextEditor
                    name="notificationDescription"
                    value={formik.values?.notificationDescription}
                    onChange={notificationHandler}
                  />
                </Col>
              </Row>
              <Row>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </Row>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditNotification;
